import { render, staticRenderFns } from "./EdenTableActions.vue?vue&type=template&id=a88850f8&scoped=true"
import script from "./EdenTableActions.vue?vue&type=script&lang=js"
export * from "./EdenTableActions.vue?vue&type=script&lang=js"
import style0 from "./EdenTableActions.vue?vue&type=style&index=0&id=a88850f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88850f8",
  null
  
)

export default component.exports